import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './security-info.reducer';
import { DevicesRouterStoreSelectors } from '../router';
import { SecurityInfo } from './security-info.state';

export const selectSecurityInfoState = createFeatureSelector(fromReducer.MdmSecurityInfoFeatureKey);

export const selectSecurityInfo = createSelector(selectSecurityInfoState, fromReducer.selectSecurityInfo);

export const selectSecurityInfoIds = createSelector(selectSecurityInfoState, fromReducer.selectSecurityInfoIds);

export const selectSecurityInfoEntities = createSelector(
  selectSecurityInfoState,
  fromReducer.selectSecurityInfoEntities
);

export const selectSecurityInfoByUdid = createSelector(
  selectSecurityInfo,
  DevicesRouterStoreSelectors.selectUdid,
  (securityInfo: SecurityInfo[], udid: string) => securityInfo.find((s) => s.udid === udid)
);

export const selectSecurityInfoByUdidLoaded = createSelector(
  selectSecurityInfoByUdid,
  (securityInfo) => securityInfo !== undefined
);
